export default __webpack_public_path__ + "static/media/cairo.bd726126.jpg";